import { useEffect } from 'react';

export const useResizeObserver = (
  targetRef: React.RefObject<HTMLElement>,
  onResize: (size: { width: number; height: number }) => void,
) => {
  useEffect(() => {
    if (!targetRef.current) return;

    const el = targetRef.current;
    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry) {
        const { width, height } = entry.contentRect;
        onResize({ width, height });
      }
    });

    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, [targetRef, onResize]);
};
